/**
 * Builds toast or flash feedback for a distribution-links save response.
 *
 * @param {Object} payload - Parsed JSON response from the backend.
 * @param {string} successMessage - Fallback message when no warning exists.
 * @returns {{type: string, message: string}} Feedback details for the UI.
 */
export function distributionUpdateFeedback(payload, successMessage) {
    if (payload && payload.warning) {
        return {
            type: 'warning',
            message: payload.warning
        };
    }

    return {
        type: 'notice',
        message: successMessage
    };
}

/**
 * Stores one flash message for the next page load.
 *
 * @param {Object} payload - Parsed JSON response from the backend.
 * @param {string} successMessage - Fallback message when no warning exists.
 * @returns {void}
 */
export function storeDistributionUpdateFlash(payload, successMessage) {
    const feedback = distributionUpdateFeedback(payload, successMessage);
    sessionStorage.setItem('flash_message', JSON.stringify([feedback.type, feedback.message]));
}

/**
 * Dispatches one in-page toast message for the current screen.
 *
 * @param {Object} payload - Parsed JSON response from the backend.
 * @param {string} successMessage - Fallback message when no warning exists.
 * @returns {void}
 */
export function dispatchDistributionUpdateToast(payload, successMessage) {
    const feedback = distributionUpdateFeedback(payload, successMessage);

    window.dispatchEvent(new CustomEvent('show-toast-notification', {
        detail: feedback
    }));
}
